import { api } from 'utils';

import { TSwitchType } from './Role.types';

export const switchType: TSwitchType = (userTypeId: string) =>
  api().post('/auth/switchType', { typeId: userTypeId });
